export default "/assets/images/mila-feed-02-thumbnail.6558f7e0512c40f7.jpg";